import Vue from 'vue'
import Router from 'vue-router'
import LandingDashboard from '@/pages/LandingDashboard'
import ProjectDashboard from '@/pages/project/ProjectDashboard'
import ProductDashboard from '@/pages/product/ProductDashboard'
import Project from '@/pages/project/Project'
import Product from '@/pages/product/Product'
import Projects from '@/pages/project/Projects'
import Login from '@/pages/Login'
import Register from '@/pages/Register'
import Profile from '@/pages/Profile'
import User from '@/pages/User'
import RequestPassword from '@/pages/RequestPassword'
import ResetPassword from '@/pages/ResetPassword'
import Messages from '@/pages/Messages'
import Donate from '@/pages/Donate'
import CreateProject from '@/pages/project/CreateProject'
import CreateProduct from '@/pages/product/CreateProduct'
import Cart from '@/pages/product/Cart'
import Delivery from '@/pages/product/Delivery'
import Orders from '@/pages/product/Orders'
import Products from '@/pages/product/Products'
import Order from '@/pages/product/Order'
import About from '@/pages/About'
import Return from '@/pages/Return'
import DisclaimerParticipate from '@/pages/DisclaimerParticipate'
import DisclaimerCreate from '@/pages/DisclaimerCreate'
import Privacy from '@/pages/Privacy'
import Terms from '@/pages/Terms'
import Shipping from '@/pages/Shipping'
import Contact from '@/pages/Contact'
import Sint from '@/pages/Sint'
import PageNotFound from '@/pages/PageNotFound'
import store from '../vuex'
import Meta from 'vue-meta'

import { messageService } from '../services/message.service'

Vue.use(Router)
Vue.use(Meta)

function getCookie (name) {
  // Split cookie string and get all individual name=value pairs in an array
  var cookieArr = document.cookie.split(';')

  // Loop through the array elements
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split('=')

    /* Removing whitespace at the beginning of the cookie name
    and compare it with the given string */
    if (name === cookiePair[0].trim()) {
      // Decode the cookie value and return
      return decodeURIComponent(cookiePair[1])
    }
  }

  // Return null if not found
  return null
}

export const router = new Router({
  mode: 'history',
  hash: false,
  routes: [
    {
      path: '/',
      name: 'LandingDashboard',
      component: LandingDashboard
    },
    {
      path: '/kickstarter',
      name: 'Project dashboard',
      component: ProjectDashboard
    },
    {
      path: '/store',
      name: 'Product dashboard',
      component: ProductDashboard
    },
    {
      path: '/project/:id-:name',
      name: 'Project',
      component: Project
    },
    {
      path: '/product/:id-:name',
      name: 'Product',
      component: Product
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Projects
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/user',
      name: 'User',
      component: User
    },
    {
      path: '/user/:id-:name',
      name: 'User by ID and name',
      component: User
    },
    {
      path: '/requestpassword',
      name: 'Request password',
      component: RequestPassword
    },
    {
      path: '/resetpassword',
      name: 'Reset password',
      component: ResetPassword
    },
    {
      path: '/messages',
      name: 'Messages',
      component: Messages
    },
    {
      path: '/messages/:id-:name',
      name: 'Messages by ID and name',
      component: Messages
    },
    {
      path: '/donate',
      name: 'Donate',
      component: Donate
    },
    {
      path: '/create',
      name: 'Create project',
      component: CreateProject
    },
    {
      path: '/store/create',
      name: 'Create product',
      component: CreateProduct
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart
    },
    {
      path: '/delivery',
      name: 'Delivery',
      component: Delivery
    },
    {
      path: '/orders',
      name: 'Orders',
      component: Orders
    },
    {
      path: '/products',
      name: 'Products',
      component: Products
    },
    {
      path: '/order/:id/redirect',
      name: 'OrderRedirect',
      component: Order,
      props: {
        redirect: true
      }
    },
    {
      path: '/order/:id',
      name: 'Order',
      component: Order
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/return',
      name: 'Return',
      component: Return
    },
    {
      path: '/disclaimer/participate',
      name: 'Disclaimer participate',
      component: DisclaimerParticipate
    },
    {
      path: '/disclaimer/create',
      name: 'Disclaimer create',
      component: DisclaimerCreate
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/terms',
      name: 'Terms',
      component: Terms
    },
    {
      path: '/shipping',
      name: 'Shipping',
      component: Shipping
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/sint',
      name: 'Sint',
      component: Sint
    },
    {
      path: '*',
      name: 'Page not found',
      component: PageNotFound
    }
  ]
})

router.beforeEach((to, from, next) => {
  store.commit('setScrollPosition', from.path)
  store.commit('activeScrollPosition', to.path)

  store.commit('clearUpAutocomplete')
  if (from.name === null && !to.path.includes('/login')) {
    // reached with direct link!
    store.commit('previousRoute', to.path)
  } else if (from.name !== null) {
    store.commit('previousRoute', from.path)
  }
  if (!to.path.includes('/login')) {
    store.commit('toRoute', to.path)
  }

  let publicPages = ['/kickstarter', '/project', '/store', '/product', '/cart', '/login', '/register', '/requestpassword', '/resetpassword',
    '/donate', '/disclaimer/participate', '/disclaimer/create', '/terms', '/shipping', '/privacy', '/contact', '/about', '/sint']
  let exceptionPages = ['/projects', '/products', '/store/create']
  let authRequired = (to.path !== '/')
  publicPages.forEach(function (page) {
    if (authRequired && to.path.includes(page) && exceptionPages.filter(function (exceptionPage) { return to.path.includes(exceptionPage) }).length === 0) {
      authRequired = false
    }
  })
  let loggedIn = !!store.state.accessToken
  let cookie = getCookie('cf_remember_me')

  if (authRequired && !loggedIn && !cookie) {
    store.commit('redirected', true)
    return next('/login')
  }

  if (loggedIn) {
    messageService.getTotalUnread()
      .then((count) => {
        store.commit('messagesUnread', count)
      }, () => {})
  }

  let found = false
  let storePages = ['/store', '/orders', '/order', '/product', '/cart', '/delivery', '/payment', '/overview', '/terms', '/shipping', '/store/create', '/products']
  let projectPages = ['/kickstarter', '/project', '/projects', '/user', '/disclaimer/participate', '/disclaimer/create']
  if (to.path === '/') {
    store.commit('store', false)
    found = true
  }
  if (!found) {
    storePages.forEach(function (page) {
      if (to.path.includes(page)) {
        store.commit('store', true)
        found = true
      }
    })
  }
  if (!found) {
    projectPages.forEach(function (page) {
      if (to.path.includes(page)) {
        store.commit('store', false)
      }
    })
  }

  let adminPages = ['/store/create', '/products']
  if (loggedIn && adminPages.filter(function (page) { return to.path.includes(page) }).length > 0 && store.state.userRoles.filter(function (role) { return role === 'ADMINISTRATOR' }).length === 0) {
    return next('/')
  }

  return next()
})



// WEBPACK FOOTER //
// ./src/router/index.js